<template>
  <AbstractPop :type-mo-full="true" :only-mo="true">
    <template v-slot>
      <div class="dialog type-filter">
        <header class="dialog-header">
          <h2>
            <span class="sr-only">필터설정 팝업</span>
          </h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <!-- D: MO에서만 존재 -->
            <h3 class="c-title-level3 only-mo">필터설정</h3>

            <div v-if="showCategoryOptionsYn" class="m-filter-wrap">
              <div class="c-inline-tabs">
                <ul>
                  <!-- D: 활성화시 is-active 및 aria-selected 추가 -->
                  <li class="tab-item">
                    <a
                      href="#"
                      class="tab-anchor"
                      role="tab"
                      :aria-selected="selectedTopCategoryCd === CATEGORY_CDS[0]"
                      :class="{
                        'is-active': selectedTopCategoryCd === CATEGORY_CDS[0],
                      }"
                      @click.prevent="selectTopCategory(CATEGORY_CDS[0])"
                    >
                      건축({{
                        Utils.currency(getTopCategoryCount(CATEGORY_CDS[0]))
                      }})
                    </a>
                  </li>
                  <li class="tab-item">
                    <a
                      href="#"
                      class="tab-anchor"
                      role="tab"
                      :aria-selected="selectedTopCategoryCd === CATEGORY_CDS[1]"
                      :class="{
                        'is-active': selectedTopCategoryCd === CATEGORY_CDS[1],
                      }"
                      @click.prevent="selectTopCategory(CATEGORY_CDS[1])"
                    >
                      공업({{
                        Utils.currency(getTopCategoryCount(CATEGORY_CDS[1]))
                      }})
                    </a>
                  </li>
                  <li class="tab-item">
                    <a
                      href="#"
                      class="tab-anchor"
                      role="tab"
                      :aria-selected="selectedTopCategoryCd === CATEGORY_CDS[2]"
                      :class="{
                        'is-active': selectedTopCategoryCd === CATEGORY_CDS[2],
                      }"
                      @click.prevent="selectTopCategory(CATEGORY_CDS[2])"
                    >
                      자보({{
                        Utils.currency(getTopCategoryCount(CATEGORY_CDS[2]))
                      }})
                    </a>
                  </li>
                </ul>
              </div>

              <MobileFilterPopRow
                v-if="lvl2Categories"
                :category-name="'시장'"
                v-model:categories="lvl2Categories"
                @select-changed="changeMoProd('1')"
              />
              <MobileFilterPopRow
                v-if="lvl3Categories"
                :category-name="'브랜드'"
                v-model:categories="lvl3Categories"
                @select-changed="changeMoProd('2')"
              />
              <MobileFilterPopRow
                v-if="lvl4Categories"
                :category-name="'제품군'"
                v-model:categories="lvl4Categories"
              />
            </div>
          </div>
        </div>

        <!-- D: MO에서만 노출 -->
        <div class="dialog-footer only-mo">
          <!-- D: 필터 선택 -->
          <div class="c-option-choice">
            <div class="choice-area">
              <div
                v-for="item in selectedCategories"
                :key="item.clsfCd"
                class="c-option-item"
              >
                <span class="text"
                  >{{ item.clsfNm }}(<span class="system">{{
                    Utils.currency(item.productCount)
                  }}</span
                  >)</span
                >
                <button
                  typee="button"
                  class="btn-delete"
                  @click="removeSelect(item)"
                >
                  <i class="c-icon icon-medium-x size-xxsmall"></i>
                  <span class="sr-only">삭제</span>
                </button>
              </div>
            </div>
          </div>
          <!-- // D: 필터 선택 -->

          <div class="c-btn-area">
            <button
              type="button"
              class="c-button type-secondary"
              @click="resetSelect"
            >
              <span>초기화</span>
            </button>
            <button
              type="button"
              class="c-button type-primary"
              @click="() => emits('categoriesSelected', searchCategories)"
            >
              <span> 제품찾기 </span>
            </button>
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>
</template>
<script setup>
import {
  onMounted,
  defineEmits,
  defineModel,
  computed,
  defineProps,
  ref,
  nextTick,
  inject,
} from "vue";
import MobileFilterPopRow from "@/components/paintpro/prod/moFilterPopRow.vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import Utils from "@/js/utils";
import { api } from "@/plugins/api";

const emits = defineEmits(["close", "categoriesSelected"]);
const url = inject("url_prefix");
const props = defineProps({
  searchCategories: {
    type: Object,
    required: true,
  },
  searchParams: {
    type: Object,
    required: true,
  }
});

const changeMoProd = async(gubn) => {

  var strArray2 = Array();
  [...searchCategories.value.lvl2Categories].filter((item) => item.selected === true).forEach(
  (data) => strArray2.push(data.clsfCd)
  );

  var strArray3 = Array();
  [...searchCategories.value.lvl3Categories].filter((item) => item.selected === true).forEach(
  (data) => strArray3.push(data.clsfCd)
  );

  var strArray4 = Array();
  [...searchCategories.value.lvl4Categories].filter((item) => item.selected === true).forEach(
  (data) => strArray4.push(data.clsfCd)
  );

  const res = await api.post(`${url}/product/search-categories`, { keyword: searchParams.value.keyword.trim(), clsfCdListLvl2 : strArray2, clsfCdListLvl3 :strArray3 });
  const { resultCode } = res;
  if (resultCode !== 200) {return;}

  if(gubn=='1'){
    searchCategories.value.lvl3Categories = res.data.lvl3Categories;
    
    for(var lvl3i=0; lvl3i<strArray3.length; lvl3i++){
      for(var lvl3ii=0; lvl3ii<searchCategories.value.lvl3Categories.length; lvl3ii++){
        if(strArray3[lvl3i] == searchCategories.value.lvl3Categories[lvl3ii].clsfCd){
          searchCategories.value.lvl3Categories[lvl3ii].selected = true;
        }
      }    
    }
  }

  searchCategories.value.lvl4Categories = res.data.lvl4Categories;

  for(var lvl4i=0; lvl4i<strArray4.length; lvl4i++){
    for(var lvl4ii=0; lvl4ii<searchCategories.value.lvl4Categories.length; lvl4ii++){
      if(strArray4[lvl4i] == searchCategories.value.lvl4Categories[lvl4ii].clsfCd){
        searchCategories.value.lvl4Categories[lvl4ii].selected = true;
      }
    }    
  }

  window.dispatchEvent(new Event('resize'));
};

const searchCategories = ref(
  JSON.parse(JSON.stringify(props.searchCategories))
);

const searchParams = ref(
  JSON.parse(JSON.stringify(props.searchParams))
);

const selectedTopCategoryCd = defineModel("selectedTopCategoryCd", {
  required: true,
});

const CATEGORY_CDS = ["P0101", "P0102", "P0103"]; // P0101: 건축, P0102: 공업용, P0103: 자보용
const showCategoryOptionsYn = ref(true);

onMounted(() => {});

const lvl2Categories = computed(() => {
  if (!searchCategories.value) return [];

  return searchCategories.value.lvl2Categories.filter(
    (item) => item.topCd === selectedTopCategoryCd.value
  );
});

const lvl3Categories = computed(() => {
  if (!searchCategories.value) return [];

  return searchCategories.value.lvl3Categories.filter(
    (item) => item.topCd === selectedTopCategoryCd.value
  );
});

const lvl4Categories = computed(() => {
  if (!searchCategories.value) return [];

  return searchCategories.value.lvl4Categories.filter(
    (item) => item.topCd === selectedTopCategoryCd.value
  );
});

const selectedCategories = computed(() => {
  if (!searchCategories.value) return [];

  return [
    ...searchCategories.value.lvl2Categories,
    ...searchCategories.value.lvl3Categories,
    ...searchCategories.value.lvl4Categories,
  ].filter((item) => item.selected === true);
});

const resetSelect = () => {
  [
    ...searchCategories.value.lvl2Categories,
    ...searchCategories.value.lvl3Categories,
    ...searchCategories.value.lvl4Categories,
  ].forEach((item) => (item.selected = false));
};

const removeSelect = (item) => {
  item.selected = false;
};

const getTopCategoryCount = (code) => {
  if (!searchCategories.value) return 0;

  const category = searchCategories.value.topCategories.find(
    (item) => item.clsfCd === code
  );

  return category ? category.productCount : 0;
};

const selectTopCategory = (code) => {
  if (getTopCategoryCount(code) === 0) return;

  selectedTopCategoryCd.value = code;

  showCategoryOptionsYn.value = false;
  nextTick(() => {
    showCategoryOptionsYn.value = true;
  });
};
</script>
